import { Injectable } from "@angular/core";
import { environment } from "src/environments/environment";
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { observable, Observable } from "rxjs";
import { tap } from "rxjs/operators";
import { VehicleRelationship } from "./api-interfaces/vehicleRelationship.interface";
import { HelperService } from "../helperService";

@Injectable({
    providedIn: 'root'
})
export class APIVehicleRelationship {
    
    ApiURL: string = '';
    
    constructor(private http: HttpClient,public helperService: HelperService) {
        // TODO: create environment variable
        this.ApiURL = environment.VehicleRelationShipUrl + 'RelationshipVehicle'
    }

    public getAllVehicleRelationships(): Observable<VehicleRelationship[]>{
        const headers = new HttpHeaders().set('Authorization', `Bearer ${this.helperService.TokenBooking}`);
        const requestOptions = {
            headers: headers,
          };
        return this.http.get<VehicleRelationship[]>(this.ApiURL,requestOptions);
    }

    public getVehicleRelationshipsById(vehicleRelationshipId): Observable<VehicleRelationship>{
        const headers = new HttpHeaders().set('Authorization', `Bearer ${this.helperService.TokenBooking}`);
        const requestOptions = {
            headers: headers,
          };
        return this.http.get<VehicleRelationship>(this.ApiURL + "/" + vehicleRelationshipId,requestOptions);
    }
 
}

    
